import { PanelCsvFilelds } from 'cloud-shared-lib';

export enum CsvEncodingEnum {
  Utf8Bom = 0,
  Utf8,
}

export class CsvSchema {
  id: number;
  name = '';
  byDefault = true;
  active = false;
  fieldsOrder: PanelCsvFilelds = new PanelCsvFilelds();
  startImportIndex = 0;
  separator: ';' | ',' = ';';
  encoding: CsvEncodingEnum = CsvEncodingEnum.Utf8Bom;
}
